export const AttachmentTypename = "AttachmentType" as const

export const AttachmentsAPIType = "attachments" as const
export const AttachmentCategoriesAPIType = "attachment_categories" as const

export const AttachmentAcceptedFileTypesAPIType =
  "attachment_file_extensions" as const
